import styled, {css} from "styled-components";

export const HeaderHeight = "94px";

export const HeaderStyle = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: ${HeaderHeight};
    z-index: 1;
    padding: 0 42px 0 calc((100vw - 1500px)/2);
    font-size: 16px;
    font-weight: 500;
`;


export const Logo = styled.img`
    width: 564px;
`;

export const NavStyle = styled.nav`
    display: flex;
    align-items: center;
    margin-left: 120px;
`;
export const NavItemStyle = styled.a<{active?: boolean}>`
    display: flex;
    height: ${HeaderHeight};
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    color: #1BEDE1;
    position: relative;
    text-decoration: none;
    &:not(:last-child){
        margin-right: 46px;
    }
    ${({active}) => active 
            ? css`
                &:after{
                    content: "";
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 3px;
                    background: #fff;
                }
            ` 
            : null}
`;

export const ConnectButton = styled.button`
    width: 147px;
    height: 48px;
    border: 1px solid #fff;
    border-radius: 8px;
    text-align: center;
    background: transparent;
    outline: none;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    box-sizing: border-box;
`;

export const Address = styled.span`
    cursor: pointer;
`;
